<template>
  <div class="pcb-parcel-shipInfo jianju" :style="{ width: width, backgroundColor: bg }">
    <div class="calculatedPrice">
      <span class="cp">Calculated Price:</span>
      <span>
        <span class="disPrice">
          <span class="pcb-cart-orgPrice" v-show="stauts.realPrice > 0">${{ stauts.realPrice.toFixed(2) }}</span>
          ${{ checkedItem?.ShipPrice.toFixed(2) ?? "--" }}</span>
      </span>
    </div>
    <div class="pcb-parcel-boxSelSC" @click.stop.prevent="handelBoxSelSC">
      <div class="custom-input" style="flex: 2; width: 220px">
        <icon-user class="input-prefix" />
        <span class="input-content">{{ cityName || "--" }}</span>
        <icon-down class="input-suffix" />
      </div>
      <div class="custom-input" style="flex: 1; width: 160px">
        <span class="input-content">
          <img v-show="checkedItem?.Pic" style="max-height: 22px; width: auto; max-width: 77px"
            :src="imgPath + checkedItem?.Pic" />
          <span v-show="!checkedItem?.Pic">-</span>
        </span>
        <icon-down class="input-suffix" />
      </div>
    </div>
    <div class="pcb-parcel-shipTime">
      <span class="title">Shipping Time</span>
      <span class="value">{{ checkedItem?.ShipDays || "--" }} Days</span>
    </div>
    <div class="pcb-parcel-shipWeight">
      <span class="title">Weight</span>
      <span class="value" data-weight="0">{{ checkedItem?.Weight?.toFixed(2) || "--" }} kg</span>
    </div>
    <div class="desc">
      <p class="w" style="color: #8c8c8c">
        <svg style="width: 16px; height: 16px; transform: translateY(3px)" t="1761704690888" class="icon"
          viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4661" width="200" height="200">
          <path
            d="M512.439682 869.692569a357.268402 357.268402 0 1 1 357.268402-357.237373 357.671779 357.671779 0 0 1-357.268402 357.237373m0-658.653497a301.385095 301.385095 0 1 0 301.416124 301.416124A301.757444 301.757444 0 0 0 512.439682 211.039072"
            p-id="4662" fill="#999999"></path>
          <path
            d="M536.642335 567.562777h-48.032958l-8.564016-202.557594h64.788642z m6.702274 92.342432h-61.809854v-62.058086h61.809854z"
            p-id="4663" fill="#999999"></path>
        </svg>You can select your shipping option on order confirmation page.
      </p>
      <p class="w pcbaTip" style="color: #8c8c8c; display: none; width: 443px">
        <svg style="width: 16px; height: 16px; transform: translateY(3px)" t="1761704690888" class="icon"
          viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4661" width="200" height="200">
          <path
            d="M512.439682 869.692569a357.268402 357.268402 0 1 1 357.268402-357.237373 357.671779 357.671779 0 0 1-357.268402 357.237373m0-658.653497a301.385095 301.385095 0 1 0 301.416124 301.416124A301.757444 301.757444 0 0 0 512.439682 211.039072"
            p-id="4662" fill="#999999"></path>
          <path
            d="M536.642335 567.562777h-48.032958l-8.564016-202.557594h64.788642z m6.702274 92.342432h-61.809854v-62.058086h61.809854z"
            p-id="4663" fill="#999999"></path>
        </svg>The accurate shipping fee will be calculated after you upload your BOM.
      </p>
    </div>
  </div>
  <Modal v-model:visible="modalVisible" :footer="false" :header="false" :width="650" :hide-cancel="true"
    :hide-title="true" :esc-to-close="false" :mask-closable="false" :align-center="true" :simple="true">
    <div style="
        padding-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      ">
      <div style="">
        <b style="
            font-size: 16px;
            font-weight: 600;
            color: #333333;
            margin-right: 10px;
          ">Ship to</b>
        <a-select size="large" :style="{ width: '250px' }" placeholder="GERMANY" v-model="cityId" allow-search
          @change="changeCountry">
          <a-option v-for="item in props.countrys" :key="item.Id" :value="item.Id">{{ item?.CountryName ?? "-"
          }}</a-option>
        </a-select>
      </div>
      <icon-close class="close-icon" @click="modalVisible = false" />
    </div>

    <div class="shipping-table">
      <div class="shipping-header">
        <div>Shipping Method</div>
        <div>Cost</div>
        <div>Delivery Time</div>
      </div>
      <!-- shipList -->
      <div class="shipping-row" v-for="item in list" :key="item.name">
        <div class="shipping-method">
          <div class="radio-wrapper">
            <Radio size="large" @change="handleChange(item)" v-model="item.checked"></Radio>
          </div>
          <div style="width: 80px">
            <img :src="imgPath + item.Pic" alt="DHL" class="carrier-logo" />
          </div>
          <span class="carrier-name">{{ item.ShipName }}</span>
        </div>
        <div class="cost-wrapper">
          <!-- <span class="original-price">${{ item.OrgShipPrice }}</span> -->
          <span class="current-price">${{ item.ShipPrice }}</span>
        </div>
        <div class="delivery-time">{{ item.ShipDays }} Days</div>
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from "@arco-design/web-vue";
import { imgPath } from "../../config/default";
import {
  Select as aSelect,
  Option as aOption,
  Radio,
} from "@arco-design/web-vue";
import { IconUser, IconDown, IconClose } from "@arco-design/web-vue/es/icon";
import { computed, ref, watch } from "vue";
const props = defineProps({
  width: {
    type: String,
    default: () => "400px",
  },
  bg: {
    type: String,
    default: () => "#fff",
  },
  stauts: {
    type: Object,
    default: () => ({}),
  },
  countrys: {
    type: Array,
    default: () => [],
  },
  CalShip: {
    type: Function,
    default: () => {
      return [];
    },
  },
});
const selectedItem = ref({});
//   切换快递
function handleChange(item, close = false) {
  selectedItem.value = item;
  list.value = list.value.map((listItem) => ({
    ...listItem,
    checked: listItem.ShipId === item.ShipId,
  }));
  if (close === false) {
    modalVisible.value = close;
  }
}
const cityId = ref(null);
const cityName = computed(() => {
  return (
    props.countrys.find((item) => item.Id === cityId.value)?.CountryName ?? "-"
  );
});
async function fetchShipList(cid, otherWeight) {
  try {
    // 构建查询参数
    const otherWeight = props.stauts?.list[props.stauts?.selected]?.PcbOrder?.TotalWeight??0;
    const params = new URLSearchParams({
      act: 'CalcShipList',
      cid: cid,
      otherweight: otherWeight
    });

    // 发送请求
    const response = await fetch(`/ashx/common.ashx?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    setShipList(data.attr||[])
    if (data && Array.isArray(data)) {
     
    }

  } catch (error) {
    // 可以添加错误提示
    // Message.error('获取快递列表失败');
    throw error;
  }
}
function setShipList(shipList){
  list.value = shipList.map((item) => ({
        ...item,
        checked: false,
      }));
      if (shipList.length > 0) {
        const currentSelectedId = selectedItem.value?.ShipId;
        const previousSelected = currentSelectedId
          ? shipList.find((item) => item.ShipId === currentSelectedId)
          : null;

        const itemToSelect = previousSelected || shipList[0];
        handleChange(itemToSelect, true);
      }
}
// 调用本地计价函数,传递国家ID,获取快递列表
function changeCountry(value) {
  list.value = []
  // 只在值确实改变时才更新 cityId，避免触发 @change 导致重复调用
  if (value && cityId.value !== value) {
    cityId.value = value;
  }
  if (window?.CalShip && window.location.href.indexOf('rigidflex-quote.html') > -1) {
    window?.CalShip(value, (shipList) => {
      setShipList(shipList);
    });
  }
  else {
    fetchShipList(value);
  }
}
const list = ref([

]);
defineOptions({
  name: "pcb-parcel",
});
const checkedItem = computed(() => {
  return list.value.find((item) => item.checked);
});
const modalVisible = ref(false);
function handelBoxSelSC() {
  modalVisible.value = true;
}
function init() {
  list.value = []
  if (cityId.value) {
    changeCountry(cityId.value);
    return;
  }

  const aShipNo = Number(window?.$.cookie("AivonShipNo"));
  if (aShipNo) {
    cityId.value = aShipNo;
    changeCountry(aShipNo);
    return;
  }

  if (props.countrys && props.countrys.length > 0) {
    cityId.value = props.countrys[0].Id;
    changeCountry(props.countrys[0].Id);
  }
}
defineExpose({
  init,
});
</script>
<style lang="css" scoped>
.close-icon {
  cursor: pointer;
  font-size: 25px;
}

.close-icon:hover {
  color: var(--primary-color);
  transition: all 0.3s ease;
}

:deep(.arco-modal-header) {
  padding: 30px 20px !important;
  border-bottom: none !important;
}

.calculatedPrice {
  height: 42px;
  border-radius: 0px 0px 0px 0px;
  line-height: 42px;
}

.calculatedPrice .cp {
  float: left;
  font-family: HarmonyOS_Sans, HarmonyOS_Sans;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  /*line-height: 23px;*/
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.calculatedPrice .orgPrice,
.disPrice {
  float: right;
  font-style: normal;
  text-transform: none;
  font-family: HarmonyOS_Sans, HarmonyOS_Sans;
  font-weight: bold;
  line-height: 42px;
}

.calculatedPrice .orgPrice {
  position: relative;
  top: 5px;
  font-size: 16px;
  color: #bfbfbf;
  margin-right: 8px;
  text-decoration-line: line-through;
}

.pcb-cart-orgPrice {
  position: relative;
  top: 0px;
  font-size: 16px;
  color: #bfbfbf;
  margin-right: 8px;
  text-decoration-line: line-through;
}

.calculatedPrice .disPrice {
  font-size: 16px;
  font-weight: bold;
  color: var(--primary-color, #0060ff);
}

.pcb-parcel-shipInfo {
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 0px 0px 0px 0px;
  padding: 16px 1em !important;
}

.pcb-parcel-boxSelSC {
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 8px 0;
}

.pcb-parcel-shipInfo .budgetPrice {
  text-align: left;
  font-style: normal;
  text-transform: none;
  font-family: HarmonyOS_Sans, HarmonyOS_Sans;
  height: 24px;
  line-height: 23px;
  margin-bottom: 8px;
}

.pcb-parcel-shipInfo .budgetPrice .title {
  width: 178px;
  height: 24px;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  line-height: 23px;
}

.pcb-parcel-shipInfo .budgetPrice .orgvalue {
  display: none;
  font-family: HarmonyOS_Sans;
  font-size: 16px;
  font-weight: normal;
  align-items: center;
  letter-spacing: 0px;
  text-decoration: line-through;
  float: right;
  color: #c7c7cc;
  margin-right: 4px;
}

.pcb-parcel-shipInfo .budgetPrice .youhuivalue {
  font-weight: bold !important;
  color: var(--primary-color, #0060ff) !important;
}

.pcb-parcel-shipList .currenShipPrice {
  font-family: HarmonyOS_Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  align-items: center;
  letter-spacing: 0px;
  color: var(--primary-color, #0060ff) !important;
  margin-left: 4px;
}

.pcb-parcel-shipList .shipprice.activity {
  text-decoration: line-through !important;
  /* 外部/Grays/Gray 2 */
  color: #aeaeb2 !important;
  font-family: HarmonyOS_Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  align-items: center;
  letter-spacing: 0px;
  text-decoration: line-through;
}

.pcb-parcel-shipInfo .budgetPrice .value {
  /*width: 28px;*/
  height: 24px;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 23px;
  float: right;
  text-align: right;
}

.pcb-parcel-shipInfo .shipTime,
.pcb-parcel-shipWeight {
  font-family: HarmonyOS_Sans, HarmonyOS_Sans;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 32px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  width: 100%;
  margin-bottom: 8px;
}

.pcb-parcel-shipInfo .shipTime .value,
.pcb-parcel-shipWeight .value {
  float: right;
  font-weight: 400 !important;
}

.pcb-parcel-shipInfo .desc {
  font-family: HarmonyOS_Sans, HarmonyOS_Sans;
  font-weight: 400;
  font-size: 12px;
  color: #8c8c8c;
  line-height: 17px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.pcb-parcel-shipInfo .desc i {
  margin-right: 8px;
}

.arco-input-wrapper.arco-input-disabled {
  border: 1px solid #ccc !important;
  border-radius: 3px !important;
  background-color: #fff;
}

.custom-input {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 36px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.input-prefix {
  margin-right: 8px;
  font-size: 16px;
  color: #666;
}

.input-content {
  flex: 1;
  font-size: 14px;
  height: 22px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.input-suffix {
  margin-left: 8px;
  font-size: 14px;
  color: #666;
  transition: transform 0.2s;
}

.shipping-table {
  width: 100%;
  max-width: 640px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.shipping-header {
  display: grid;
  grid-template-columns: 3fr 1.5fr 2fr;
  background-color: #f8f8f8;
  border-bottom: 1px solid #e0e0e0;
  padding: 12px 20px;
}

.shipping-header>div {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.shipping-row {
  display: grid;
  grid-template-columns: 3fr 1.5fr 2fr;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.pcb-parcel-shipTime {
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
}

.shipping-row:last-child {
  border-bottom: none;
}

.shipping-row:hover {
  background-color: #fafafa;
}

.shipping-method {
  display: flex;
  align-items: center;
  gap: 12px;
}

.radio-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.radio-input {
  width: 20px;
  height: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.2s;
}

.radio-input.checked {
  border-color: #333;
  border-width: 2px;
}

.radio-input.checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background-color: #333;
  border-radius: 50%;
}

.carrier-logo {
  height: 24px;
  max-width: 77px;
  max-height: 22px;
  width: auto;
  object-fit: contain;
}

.carrier-name {
  font-size: 15px;
  color: #333;
  font-weight: 400;
}

.cost-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.original-price {
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
}

.current-price {
  /* font-size: 15px; */
  /* font-weight: 600; */
  /* color: var(--warning-color-1); */
}

.delivery-time {}
</style>
